<autocomplete-option>
  <div class="main">
    <span [innerHTML]="location.city_utf8 | highlight: highlight"></span>
    ({{ location.region }})
  </div>
</autocomplete-option>
